import { findByIndexOrProperty } from 'utils/array';

export default function findItemByValue(items, itemOrIndex) {
    return findByIndexOrProperty(items, itemOrIndex, 'value') || null;
}
